import {
	FormControl,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IMessage } from 'src/actions/message';
import MessageDialog from 'src/components/MessageDialog';
import QuickModeCard from 'src/components/QuickModeCard';
import { IRootState } from 'src/reducers';
import QuickModeFactory from 'src/scenario/QuickModeFactory';
import { getSystemMst, MasterItemCode } from 'src/utils/MasterData';
import * as Actions from '../actions/quickModeContens';
import ContentsCreateImage from '../images/contentsCreate.png';
import ContentsCutOffImage from '../images/contentsCutOff.png';
import DataUpdateImage from '../images/dataUpdate.png';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';
function styles(theme: Theme) {
	return createStyles({
		container: {
			display: 'flex',
			flexWrap: 'wrap',
			height: '100%',
			justifyContent: 'center',
		},
		formControl: {
			marginBottom: '10px',
			marginLeft: '20px',
			width: '220px',
		},
		paper: {
			padding: '10px',
			width: '300px',
		},
		root: {
			flexGrow: 1,
			padding: 10,
			wordBreak: 'break-all',
		},
	});
}

interface IState {
	orgId: string;
	errorMessage: IMessage[];
	openErrorDialog: boolean;
	errorFlg: boolean;
}

class QuickMode extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			errorFlg: false,
			errorMessage: [],
			openErrorDialog: false,
			orgId: '',
		};
		this.handleChangeOrg = this.handleChangeOrg.bind(this);
	}

	public componentDidMount() {
		this.props.createFetchManageOrg(this.props.token).then(() => {
			if (this.props.manageOrgList.length === 0) {
				const message: IMessage = {
					content: 'LMCM_E_00474',
				};
				this.setState({
					errorMessage: [message],
					openErrorDialog: true,
				});
			} else {
				this.setState({
					orgId: this.props.manageOrgList[0].org_id,
				});
				this.props.saveOrgId(this.props.manageOrgList[0].org_id);
			}
		});
	}

	public render() {
		const { classes } = this.props;
		const applicationCheckNumber = getSystemMst(
			MasterItemCode.QM_APPLICATION_CHECK_NUMBER
		);
		const careerNumber = getSystemMst(MasterItemCode.QM_CAREER_NUMBER);

		const text1 = i18n.t('QuickMode_0000');
		const text2 = i18n.t('QuickMode_0001');
		const text3 = i18n.t('QuickMode_0002', {
			applicationCheckNumber,
			careerNumber,
		});
		const enableDataUpdate =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_DATAUPDATE'
			) === -1;
		const enableContentScreate =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_CONTENTSCREATE'
			) === -1;
		const enableContentScutoff =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_CONTENTSCUTOFF'
			) === -1;
		return (
			<div className={classes.root}>
				<MessageDialog
					open={this.state.openErrorDialog}
					onClose={this.closeErrorDialog}
					contents={this.state.errorMessage}
					showCancelButton={false}
					onClickOk={this.closeErrorDialog}
				/>
				<Paper className={classes.paper}>
					<FormControl
						variant="standard"
						className={classes.formControl}
					>
						<InputLabel>{i18n.t('QuickMode_0003')}</InputLabel>
						<Select
							id="orgId"
							value={this.state.orgId}
							onChange={this.handleChangeOrg}
						>
							{this.props.manageOrgList.map(item => (
								<MenuItem value={item.org_id}>
									{item.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Paper>
				<div className={classes.container}>
					{enableDataUpdate &&
						!isMobile() &&
						!this.state.errorFlg && (
							<QuickModeCard
								ImageSrc={DataUpdateImage}
								text={text1}
								buttonName={i18n.t('QuickMode_0004')}
								onClick={this.handleOnclick(1)}
							/>
						)}
					{enableContentScreate && !this.state.errorFlg && (
						<QuickModeCard
							ImageSrc={ContentsCreateImage}
							text={text2}
							buttonName={i18n.t('QuickMode_0004')}
							onClick={this.handleOnclick(2)}
						/>
					)}
					{enableContentScutoff &&
						!isMobile() &&
						!this.state.errorFlg && (
							<QuickModeCard
								ImageSrc={ContentsCutOffImage}
								text={text3}
								buttonName={i18n.t('QuickMode_0004')}
								onClick={this.handleOnclick(3)}
							/>
						)}
				</div>
			</div>
		);
	}
	/**
	 * エラーダイアログオープン
	 */
	protected openErrorDialog = () => {
		this.setState({ openErrorDialog: true });
	};

	/**
	 * エラーダイアログクローズ
	 */
	protected closeErrorDialog = () => {
		this.setState({ openErrorDialog: false, errorFlg: true });
	};
	private handleOnclick = (num: number) => () => {
		//
		let to: any;
		switch (num) {
			case 1:
				to = Routes.getPath(Screens.QUICK_MODE_ORG_USER_REGISTER_MAIN);
				this.props.pushHistoryState(to, { org_Id: this.state.orgId });
				break;
			case 2:
				to = Routes.getPath(Screens.QUICK_MODE_CONTENTS_CREATE);
				this.props.pushHistory(to);
				break;
			case 3:
				to = Routes.getPath(Screens.QUICKMODE_STUDENT_ASSIGN);
				this.props.pushHistoryState(to, { org_Id: this.state.orgId });
				break;
			default:
				break;
		}
	};

	private handleChangeOrg(event: React.ChangeEvent<HTMLSelectElement>) {
		const value = event.target.value;
		this.setState({
			orgId: value,
		});
		this.props.saveOrgId(value);
	}
}

const mapStateToProps = (state: IRootState) => ({
	manageOrgList: state.quickModeContents.manageOrgList,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createFetchManageOrg: (token: string) => {
		const s = QuickModeFactory.createFetchManageOrg(dispatch, token);
		return s.run({});
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	saveOrgId: (orgId: string) => {
		dispatch(Actions.setOrgId({ orgId }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickMode);

const Styled = withStyles(styles)(Connected);
export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickMode.tsx